module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_add"
  }, [_c('div', {
    staticClass: "addMeterCode"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name"
  }, [_vm._v("户号")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入户号",
      "maxlength": 12,
      "disabled": ""
    },
    model: {
      value: (_vm.account),
      callback: function($$v) {
        _vm.account = $$v
      },
      expression: "account"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name"
  }, [_vm._v("表类型")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": ""
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name"
  }, [_vm._v("业主类型")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": ""
    },
    model: {
      value: (_vm.nature),
      callback: function($$v) {
        _vm.nature = $$v
      },
      expression: "nature"
    }
  }, _vm._l((_vm.natures), function(item) {
    return _c('el-option', {
      key: item.num,
      attrs: {
        "label": item.value,
        "value": item.num
      }
    })
  }), 1)], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name"
  }, [_vm._v("计量方案")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": ""
    },
    model: {
      value: (_vm.prop),
      callback: function($$v) {
        _vm.prop = $$v
      },
      expression: "prop"
    }
  }, _vm._l((_vm.props), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.plan_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("倍率")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": ""
    },
    model: {
      value: (_vm.rate),
      callback: function($$v) {
        _vm.rate = $$v
      },
      expression: "rate"
    }
  }, _vm._l((_vm.rates), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name"
  }, [_vm._v("业主姓名")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入业主姓名",
      "disabled": ""
    },
    model: {
      value: (_vm.owner_name),
      callback: function($$v) {
        _vm.owner_name = $$v
      },
      expression: "owner_name"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name"
  }, [_vm._v("业主电话")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入业主手机号",
      "maxlength": 11,
      "disabled": ""
    },
    model: {
      value: (_vm.owner_phone),
      callback: function($$v) {
        _vm.owner_phone = $$v
      },
      expression: "owner_phone"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "width": "600px"
    }
  }, [_c('span', {
    staticClass: "add_Meter_Code_Name",
    staticStyle: {
      "width": "95px"
    }
  }, [_vm._v("业主身份证")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "placeholder": "请输入业主身份证",
      "maxlength": 18,
      "disabled": ""
    },
    model: {
      value: (_vm.owner_id_number),
      callback: function($$v) {
        _vm.owner_id_number = $$v
      },
      expression: "owner_id_number"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name"
  }, [_vm._v("开户时间")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "disabled": ""
    },
    model: {
      value: (_vm.create_time),
      callback: function($$v) {
        _vm.create_time = $$v
      },
      expression: "create_time"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "width": "500px"
    }
  }, [_c('span', {
    staticClass: "add_Meter_Code_Name"
  }, [_vm._v("是否允许APP充值")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.app_pay),
      callback: function($$v) {
        _vm.app_pay = $$v
      },
      expression: "app_pay"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.app_pay),
      callback: function($$v) {
        _vm.app_pay = $$v
      },
      expression: "app_pay"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name"
  }, [_vm._v("状态")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": ""
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.statuss), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.value,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "width": "400px"
    }
  }, [_c('span', {
    staticClass: "add_Meter_Code_Name",
    staticStyle: {
      "width": "77px"
    }
  }, [_vm._v("通断状态")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": ""
    },
    model: {
      value: (_vm.power_status),
      callback: function($$v) {
        _vm.power_status = $$v
      },
      expression: "power_status"
    }
  }, _vm._l((_vm.statusd), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.value,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name"
  }, [_vm._v("楼号")]), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入楼号",
      "disabled": ""
    },
    model: {
      value: (_vm.buildnum),
      callback: function($$v) {
        _vm.buildnum = $$v
      },
      expression: "buildnum"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name"
  }, [_vm._v("单元号")]), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入单元",
      "disabled": ""
    },
    model: {
      value: (_vm.unitnum),
      callback: function($$v) {
        _vm.unitnum = $$v
      },
      expression: "unitnum"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("门牌号")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入门牌号",
      "disabled": ""
    },
    model: {
      value: (_vm.doornum),
      callback: function($$v) {
        _vm.doornum = $$v
      },
      expression: "doornum"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name"
  }, [_vm._v("建筑面积")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入建筑面积",
      "disabled": ""
    },
    model: {
      value: (_vm.floor_area),
      callback: function($$v) {
        _vm.floor_area = $$v
      },
      expression: "floor_area"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name"
  }, [_vm._v("最大限额")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入最大限额"
    },
    model: {
      value: (_vm.quota),
      callback: function($$v) {
        _vm.quota = $$v
      },
      expression: "quota"
    }
  }), _vm._v(" "), _c('small', {
    staticStyle: {
      "display": "block",
      "margin-left": "10px",
      "margin-top": "5px",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.type == '水表' ? '最大限额为正整数，>=2 且 <= 100 ,-1为不限制' : '最大限额为10的整数倍，<=1000 ，-1为不限制'))])], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "add_Meter_Code_Name"
  }, [_vm._v("备注")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "请输入需要备注的信息",
      "rows": 2,
      "type": "textarea"
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1)]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "120px",
      "margin-left": "330px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sumbit()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "120px",
      "margin-bottom": "20px",
      "margin-left": "30px"
    },
    on: {
      "click": _vm.addMeterCodeClose
    }
  }, [_vm._v("关闭")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-7eadeae9"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/changeCode.vue
// module id = 544
// module chunks = 1